module.exports = __webpack_public_path__ + "static/media/ios-phone-landscape.edb7a0aa.svg";